import { PostActionStructure } from "../ActionTypes/PostActionStructure"

export class PostReaction extends PostActionStructure {
    lower_bound = 0
    reaction = null
}